"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantUsageRing = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const util_1 = require("@app/util");
require("./assistant-usage-ring.scss");
/**
 * How much of the workspace's monthly allowance is gone, next to the disclaimer. Orange while
 * there is room, red once it is spent.
 *
 * A conic-gradient rather than the repo's SVG `ProgressCircle`: that component is built for
 * 32/40px with a centred label and is not exported from the `@ui` barrel, which at 13px with no
 * label would be more markup than the two gradients here.
 *
 * The tooltip is the figures themselves, so it needs no key of its own — the numbers carry it.
 */
const AssistantUsageRing = ({ usedPercent, used, limit, isSpent, onToggle, isPanelOpen, triggerRef, }) => {
    const label = `${(0, util_1.t)('ASSISTANT.usageConversations')}: ${used} / ${limit}`;
    const style = { '--used-percent': `${usedPercent}%` };
    if ((0, util_1.isUndefined)(onToggle)) {
        return (react_1.default.createElement("div", { className: 'ds-ma-usage-ring-anchor' },
            react_1.default.createElement("span", { className: (0, classnames_1.default)('ds-ma-usage-ring', 'is-static', { 'is-spent': isSpent }), style: style, "aria-hidden": true })));
    }
    return (react_1.default.createElement("div", { className: 'ds-ma-usage-ring-anchor', ref: triggerRef },
        react_1.default.createElement("button", { type: 'button', className: (0, classnames_1.default)('ds-ma-usage-ring', { 'is-spent': isSpent }), style: style, onClick: onToggle, "aria-haspopup": 'dialog', "aria-expanded": isPanelOpen, "aria-label": label, title: label, "data-testid": 'ai-usage-ring' })));
};
exports.AssistantUsageRing = AssistantUsageRing;
exports.default = AssistantUsageRing;
